<template>
  <placeholders :rounded="true" class="h-100">
    <div class="view-referral-wrapper mx-auto w-100 h-100" style="background: #f6f6f6">
      <div class="mx-auto" style="max-width: 1080px">
        <div class="mx-auto p-5" style="">
          <div class="referral-container bg-white mx-auto p-5 px-6 paper-shadow">
            <template v-if="practice">
              <div class="practice-header d-flex align-items-center mb-5 row">
                <div class="logo _mr-5 col-12 text-center _col-md-3">
                  <!-- TODO: Custom logos, pull from their favicon website -->
                  <img
                    v-if="practice.logo"
                    :src="practice.logo"
                    class="img-fluid"
                    style="min-height: 75px; max-height: 100px"
                  />
                  <img v-else src="@/assets/svg/logo.svg" class="img-fluid" style="width: 128px" />
                </div>
                <div class="col mt-4 _mt-md-0 text-center _text-md-left" style="font-size: 1.175rem">
                  <h1 v-if="!practice.is_logo_only">{{ practice.name }}</h1>
                  <span v-if="practice.address">
                    <font-awesome-icon icon="map-marker-alt" class="text-primary mr-2" />
                    {{ $helpers.address(practice) }}
                  </span>
                  <span v-if="practice.phone">
                    <br />
                    <font-awesome-icon icon="phone" class="text-primary mr-2" />
                    {{ practice.phone | phone }}
                  </span>
                </div>
              </div>
            </template>
            <div v-else class="referral-header">
              <div class="row mt-5">
                <div class="col-4 mx-auto">
                  <placeholders-text :lines="1" class="fixed" height="8rem" />
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-8 mx-auto">
                  <placeholders-text :lines="1" class="fixed" height="4rem" />
                </div>
              </div>
              <div class="row mt-5"><div class="col"></div></div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="4.5rem" />
                  </div>
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="4.5rem" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="4.5rem" />
                  </div>
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="4.5rem" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="3.5rem" />
                  </div>
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="3.5rem" />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="3.5rem" />
                  </div>
                  <div class="col">
                    <placeholders-text :lines="1" class="fixed" height="3.5rem" />
                  </div>
                </div>
                <placeholders-text :lines="1" class="fixed mt-5" height="3.5rem" />
                <placeholders-text :lines="1" class="fixed mt-5" height="3.5rem" />
                <placeholders-text :lines="1" class="fixed mt-5" height="3.5rem" />
              </div>
              <div class="col-12 col-sm-5 order-2 order-sm-1">
                <placeholders-img style="height: 100%" />
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-text :lines="1" class="fixed" height="8rem" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-img style="height: 100%" />
              </div>
              <div class="col">
                <placeholders-text :lines="1" class="fixed" height="8rem" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </placeholders>
</template>

<script>
export default {
  props: ['showPractice'],
  computed: {
    practice() {
      return this.showPractice
    },
  },
}
</script>

<style>
</style>